module.exports = __webpack_public_path__ + "static/media/git_image_presentation.1cbee40b.png";